module.exports = __webpack_public_path__ + "static/media/snær.fb432561.svg";